module.exports = __webpack_public_path__ + "img/8.676602a7.jpg";